// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1s7s6","right":"styles_right__1j9LN"};